import request from "root/js/request";

export const getParsersSocialPostsProducts = async ({
  source__in,
  account_name_hash__in,
  brand_id__in,
  subject_id__in,
  //
  limit,
  offset,
  search,
  ...rest
}) => {
  const response = await request({
    url: `parsers/social/posts/products/`,
    method: "get",
    params: {
      source__in,
      account_name_hash__in,
      brand_id__in,
      subject_id__in,
      //
      limit,
      offset,
      // search, // конкретно для этого запроса заменяется поиск для неполного вхождения
      product_id__startswith: search,
      ...rest,
    },
  });
  return response.data;
};
